import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const ChevronRightIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path d="M10.89 7.734 6.27 3.11a.38.38 0 0 0-.536 0l-.623.619a.373.373 0 0 0 0 .531L8.84 8l-3.73 3.74a.373.373 0 0 0 0 .531l.623.619a.38.38 0 0 0 .535 0l4.62-4.624a.373.373 0 0 0 0-.532" />
  </svg>
);
ChevronRightIcon.displayName = 'ChevronRightIcon';
export default ChevronRightIcon;
